import { Component, Input, OnInit } from '@angular/core';

import { MercadopagoApiService } from '../services/mercadopago.api.service';


@Component({
  selector: 'mp-promotion',
  templateUrl: './promotion-bank.component.html',
  styleUrls: ['./promotion-bank.component.scss']
})
export class PromotionBankComponent implements OnInit {
  @Input() url: string;
  @Input() contentSource: string;

  cardPromotions: any;

  constructor(private mercadoPagoService: MercadopagoApiService) { }

  ngOnInit() {
    this.mercadoPagoService
      .getMercadoPagoPromotions(this.url)
      .subscribe(res => this.cardPromotions = res);
  }

}
